import { getPipelineDashboardResponseSchema, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const pipelineDashboardApiEndpoints = (builder, coreApiBaseUrl) => ({
    getPipelineDashboard: builder.query({
        query: (params) => {
            const queryParams = createParams(mapToSnakeCase({
                ...params,
                status: params.status,
                pipelineName: params.pipelineName,
            }));
            return {
                url: `${coreApiBaseUrl}/pipeline-dashboard/`,
                method: 'GET',
                params: queryParams,
            };
        },
        providesTags: ['PipelineDashboard'],
        transformResponse: createTransformer(getPipelineDashboardResponseSchema, 'GetPipelineDashboard'),
    }),
});
